import { Component } from '@angular/core';
import { LoadingBaseButtonComponent } from '../loading-base-button';

@Component({
  selector: 'app-loading-stroked-button',
  templateUrl: './loading-stroked-button.component.html',
  styleUrls: ['../shared-styles.scss', './loading-stroked-button.component.scss'],
})
export class LoadingStrokedButtonComponent extends LoadingBaseButtonComponent {}
